/* ============================================================
   CUSTOMDO — cdx-tb-final.js  (v2, ersetzt v1 komplett)
   Änderungen v2:
   - Status-Erkennung korrigiert: NUR echter Adresswert zählt
     (v1 zählte Label-Text mit -> alle Stationen "✓ Ausgefüllt")
   - Adress-Doppelzeile: Label und Trigger werden getrennt erkannt
   - Panel-Hintergrund im Widget wird zur Laufzeit neutralisiert
   ============================================================ */
(function () {
  'use strict';
  var PIN = '<svg class="cd-pin" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2B2723" stroke-width="1.5"><path d="M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>';
  var PLACEHOLDER = 'Hier Adresse oder Ort auswählen *';
  /* MOBILE-SCHUTZ: Teeinblue nutzt auf kleinen Screens ein eigenes Layout
     (Overlay/Drawer). Flächen-Neutralisierung und Leerflächen-Kollaps können
     dort die Bedienoberfläche unsichtbar machen — auf Mobile wird deshalb NUR
     kosmetisch gestylt (CSS), aber nichts strukturell verändert. */
  function isMobile() { return window.innerWidth < 750; }
  /* Overlays/Drawer (fixed/absolute) niemals anfassen — auch nicht auf Desktop */
  function isOverlay(el) {
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      var pos;
      try { pos = getComputedStyle(n).position; } catch (e) { return false; }
      if (pos === 'fixed' || pos === 'sticky') return true;
      if (pos === 'absolute' && n.offsetHeight > 120) return true;
    }
    return false;
  }

  /* PATCH: '[class*="cd-station"]' matcht auch .cd-station-head/-body/-num/-ttl/
     -sub/-state → jeder Sub-Knoten galt als Station (12 gestapelte Hinweise, einer
     davon im Status-Span). Nur äußerste echte Stations-Karten verwenden. */
  function stations(root) {
    var all = Array.prototype.slice.call(root.querySelectorAll('.cd-station, .tee-station'));
    return all.filter(function (el) {
      return !all.some(function (o) { return o !== el && o.contains(el); });
    });
  }
  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }
  function setStyle(el, prop, val) { if (el && el.style[prop] !== val) el.style[prop] = val; }

  /* Der Adress-Trigger ist das KLICKBARE Element (button/role=button),
     NICHT das Label "1. Adresse oder Koordinaten eingeben *". */
  function addressTrigger(station) {
    var cands = station.querySelectorAll('button, [role="button"], [class*="autocomplete"], [class*="search"]');
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i];
      if (el.closest('.cd-station-head, .st-head')) continue;      // Kopfzeile ignorieren
      if (el.querySelector('input, select, textarea')) continue;
      var t = (el.textContent || '').trim();
      if (t.length < 80) return el;
    }
    return null;
  }

  /* Echten Wert lesen: verstecktes Input des Autocomplete oder Trigger-Text
     ohne Platzhalter/Label-Reste. */
  function addressValue(station, trg) {
    var hidden = station.querySelector('input[type="hidden"][value]:not([value=""])');
    if (hidden && hidden.value.trim().length > 3) return hidden.value.trim();
    /* PATCH: das generische erste Textfeld NUR werten, wenn es KEINEN Trigger gibt.
       Sonst zählt „Koordinaten (Optional)" als Adresse → Station fälschlich grün
       (genau der V13-Fehler 1, nur an anderer Stelle). */
    if (!trg) {
      var txt = station.querySelector('input[type="text"]');
      if (txt && txt.value.trim().length > 3) return txt.value.trim();
      return '';
    }
    var t = (trg.textContent || '')
      .replace(PLACEHOLDER, '').replace(/adresse\s*(zu\s*)?suchen?/i, '')
      .replace(/adresse oder koordinaten eingeben/i, '').replace(/[*•\s]/g, ' ').trim();
    return t.length > 3 ? t : '';
  }

  /* Leerflächen einklappen: Container, aus denen Felder ins Akkordeon gewandert
     sind, behalten Whitespace-Textknoten — die CSS-Regel `div:empty` greift dann
     NICHT und Padding/min-height bleiben als leerer Scrollbereich stehen.
     Hier zählt "leer" = kein sichtbarer Text UND kein Medien-/Formularelement.
     Klassen werden nur bei echter Zustandsänderung gesetzt (kein Observer-Loop). */
  /* Elemente, die legitim (noch) leer sein dürfen und nie eingeklappt werden */
  /* Auch die eigene Wizard-Huelle nie einklappen: Kopf und Punkte sind im Moment
     ihrer Erzeugung leer, und der Kollaps hat sie dadurch versteckt (gefunden mit
     der Nachbildung eines Produkts ohne Stationen, 01.08.2026). */
  var KEEP = '#teeinblue-form, .cd-station, .cd-stations, .cd-station-body, .cd-pin,' +
    '.cdx-wz-head, .cdx-wz-dots, .cdx-wz-title, .cdx-wz-foot, .cdx-wz-head *,' +
    '.cd-required-hint, .shopify-payment-button, [class*="payment"], .product-form__buttons,' +
    '.cdx-stickybar, [class*="teeinblue"], [class*="preview"], [class*="gallery"], [class*="canvas"]';
  function collapseEmpties(widget) {
    if (!widget || isMobile()) return; // Mobile: nichts einklappen
    var els = widget.querySelectorAll('div, section, p, fieldset');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.matches(KEEP) || el.closest('.cd-station-head')) continue;
      if (el.querySelector('#teeinblue-form')) continue; // Vorfahr des Widgets nie einklappen
      if (isOverlay(el)) continue;                        // Overlay/Drawer nie einklappen
      var hasText = (el.textContent || '').trim().length > 0;
      var hasStuff = el.querySelector('img, svg, canvas, video, iframe, input, select, textarea, button, [role="button"]');
      var want = !hasText && !hasStuff;
      /* NUR bei echter Zustandsänderung schreiben: classList.add/remove setzt das
         class-Attribut auch dann neu, wenn sich nichts ändert → Mutation →
         Observer → Dauerschleife (gemessen ~480/s). */
      if (want !== el.classList.contains('cd-collapsed')) el.classList.toggle('cd-collapsed', want);
    }
  }

  /* Diagnose: window.cdxTbGaps() — listet die größten Elemente ohne sichtbaren
     Inhalt (Klassenname + Höhe). Ausgabe an den Entwickler schicken, falls trotz
     Kollaps noch eine Leerfläche bleibt. */
  window.cdxTbGaps = function () {
    var root = document.querySelector('.product__info-container') || document.body;
    var out = [];
    Array.prototype.forEach.call(root.querySelectorAll('*'), function (el) {
      /* SVG-Elemente haben kein offsetHeight und className ist ein SVGAnimatedString
         (Diag zeigte "undefinedpx svg.[object SVGAnimatedString]") */
      var h = el.offsetHeight;
      if (typeof h !== 'number' || h < 60) return;
      if ((el.textContent || '').trim().length > 0) return;
      if (el.querySelector('img, svg, canvas, video, iframe, input, select, textarea, button')) return;
      var cls = el.className;
      cls = (cls && cls.baseVal !== undefined) ? cls.baseVal : String(cls || '');
      out.push({ tag: el.tagName, cls: cls.slice(0, 80), h: h, id: el.id || '' });
    });
    out.sort(function (a, b) { return b.h - a.h; });
    console.log('cdxTbGaps:', JSON.stringify(out.slice(0, 15), null, 2));
    return out.slice(0, 15);
  };

  /* Die Adressfeld-Box INLINE mit !important setzen. Grund: der Panel-
     Neutralisierer unten setzt bei unerkannten Containern inline
     `background:transparent !important` — inline schlägt jede Stylesheet-Regel,
     der Kasten war dadurch weg (Padding blieb, Fläche/Rahmen fehlten).
     Inline gegen inline gewinnt, wer zuletzt schreibt: das sind wir. */
  function paintBox(el, filled) {
    if (!el) return;
    var border = filled ? '1.5px solid rgba(43,39,35,.2)' : '2px solid #D99A4E';
    if (el.style.getPropertyValue('background') === '#FFFDF9' &&
        el.style.getPropertyValue('border') === border) return; // kein unnötiger Schreibvorgang
    el.style.setProperty('background', '#FFFDF9', 'important');
    el.style.setProperty('border', border, 'important');
    el.style.setProperty('border-radius', '14px', 'important');
    el.style.setProperty('min-height', '48px', 'important');
    el.style.setProperty('box-shadow', 'none', 'important');
  }

  /* Sicherheitsnetz gegen unsichtbare Seite: bleibt ein Einblend-Element (Dawn
     scroll-trigger) oder ein Vorfahr der Kaufspalte fast durchsichtig haengen,
     wird es sichtbar gemacht. Greift unabhaengig von der Ursache. */
  function unhideStuck() {
    var els = document.querySelectorAll('.scroll-trigger, .product__info-wrapper, .product__media-wrapper');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], o;
      try { o = parseFloat(getComputedStyle(el).opacity); } catch (e) { continue; }
      if (o < 0.5 && el.style.opacity !== '1') {
        el.style.setProperty('opacity', '1', 'important');
        el.style.setProperty('transform', 'none', 'important');
      }
    }
  }
  /* Galerie-Rettung: greift NUR im nachweislich kaputten Zustand — Wrapper hat
     Bilder, aber 0 Pixel Hoehe, und Teeinblue zeigt auch keine eigene Galerie.
     Dann bekommt der Wrapper wieder volle Breite (inline, damit es jede
     !important-Regel schlaegt). Ist die Seite gesund oder rendert T&B seine
     eigene Vorschau, passiert nichts — die Bedingung ist dann nicht erfuellt. */
  /* ZURUECKGENOMMEN (Desktop-Regression): Die Rettung hat auf dem Desktop gegriffen,
     solange die Galerie beim Laden noch 0 Pixel hoch war, und dann Wrapper UND
     Vorfahren auf display:block/width:100% gezwungen — damit war die Zweispaltigkeit
     zerstoert. Der eigentliche Galerie-Fix sitzt ohnehin im CSS (Mobile-Overrides mit
     !important) und ist am Geraet mit h=372 belegt. Kein JS greift mehr ins Layout. */
  setTimeout(unhideStuck, 1200);
  setTimeout(unhideStuck, 3000);

  /* Sicherheitsnetz gegen genau den Fehler, der den Konfigurator lahmgelegt hat:
     Teeinblues .tee-form-wrapper startet bei opacity:0 und wird per Animation
     sichtbar. Bleibt er nach 6 s unsichtbar, obwohl Inhalt da ist, blenden wir ihn
     ein. Nur opacity — kein Layout, keine Struktur. */
  setTimeout(function () {
    var w = document.querySelector('.tee-form-wrapper');
    if (!w || !w.children.length) return;
    var o;
    try { o = parseFloat(getComputedStyle(w).opacity); } catch (e) { return; }
    if (o < 0.5) w.style.setProperty('opacity', '1', 'important');
  }, 6000);

  function upgrade() {
    var widget = document.querySelector('.tee-customization') || document.querySelector('[class*="tee-"]');
    if (!widget) return;
    /* MOBILE-GARANTIE: dort greift auch das Skin-CSS nicht (Media-Query ab 750px).
       Teeinblue rendert mobil ein eigenes Layout inkl. Galerie-Uebernahme —
       jede Manipulation kann diese Mechanik stoeren. Nur Diagnose zulassen. */
    if (isMobile()) return;   /* Mobile: Teeinblue unangetastet lassen */
    var scope = widget.closest('form') || widget.parentElement || document;

    stations(scope).forEach(function (station) {
      var body = station.querySelector('.cd-station-body, .st-body') || station;

      /* 1) Genau EIN Pflicht-Hinweis, in der Station */
      if (!body.querySelector('.cd-required-hint')) {
        var lbl = body.querySelector('label');
        var hint = document.createElement('div');
        hint.className = 'cd-required-hint';
        hint.textContent = 'Pflichtfeld — erscheint auf deinem Poster';
        if (lbl) lbl.parentNode.insertBefore(hint, lbl); else body.insertBefore(hint, body.firstChild);
      }

      /* 2) Trigger aufwerten (einmalig) */
      var trg = addressTrigger(station);
      if (trg && !trg.classList.contains('cd-address-trigger')) {
        trg.classList.add('cd-address-trigger');
        trg.style.position = 'relative';
        trg.insertAdjacentHTML('afterbegin', PIN);
        /* PATCH: Aufforderungstext NUR setzen, wenn dort noch keine echte Adresse
           steht — sonst überschreibt der erste Durchlauf nach einem Reload die
           bereits gewählte Adresse des Kunden. */
        var cur = (trg.textContent || '').trim();
        var looksEmpty = cur.length < 25 || /^\s*adresse\s*(zu\s*)?such/i.test(cur) ||
                         /adresse oder koordinaten/i.test(cur);
        if (looksEmpty) {
          for (var i = 0; i < trg.childNodes.length; i++) {
            var n = trg.childNodes[i];
            if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = ' ' + PLACEHOLDER; break; }
          }
        }
      }

      /* 2b) Fallback: kein Klick-Trigger gefunden → das Pflicht-Eingabefeld selbst
         bekommt die Adressfeld-Box (weiß, Gold-Rahmen solange leer) + Ink-Pin.
         Sonst hätte das wichtigste Feld gar keinen Kasten. */
      if (!trg) {
        var fld = body.querySelector('input[type="text"], input:not([type]), textarea');
        if (fld && !fld.classList.contains('cd-addr-field')) {
          fld.classList.add('cd-addr-field');
          if (!fld.getAttribute('placeholder')) fld.setAttribute('placeholder', PLACEHOLDER);
          var host = fld.parentElement;
          if (host && !host.querySelector('.cd-pin')) {
            host.style.position = 'relative';
            host.insertAdjacentHTML('afterbegin', PIN);
          }
        }
        if (fld) fld.classList.toggle('cd-filled', (fld.value || '').trim().length > 3);
      }

      /* 3) Status nur bei echtem Wert */
      var val = addressValue(station, trg);
      var filled = val.length > 3;
      if (trg) trg.classList.toggle('cd-filled', filled);
      var head = station.querySelector('.cd-station-head, .st-head');
      if (head) {
        var state = head.querySelector('.cd-station-state, .st-state');
        var num = head.querySelector('.cd-station-num, .st-num');
        var sub = head.querySelector('.cd-station-sub, .st-sub');
        /* PATCH: nur bei Änderung schreiben — der Observer lauscht auf
           characterData/childList; unbedingtes Schreiben triggert sich selbst
           (gemessene Dauerschleife: ~250 Mutationen/s). */
        if (state) { setText(state, filled ? '✓ Ausgefüllt' : 'Offen');
                     setStyle(state, 'color', filled ? '#5A8A5A' : '#B07B34'); }
        if (num) { setStyle(num, 'background', filled ? '#7FBF7F' : '');
                   setStyle(num, 'borderColor', filled ? '#7FBF7F' : ''); }
        if (sub) setText(sub, filled ? ' · ' + val : '');
        station.classList.toggle('done', filled);
      }

      /* 3b) Box des Adressfelds inline erzwingen (weißer Kasten + Rahmen) */
      paintBox(trg, filled);
      var af = body.querySelector('.cd-addr-field');
      if (af) paintBox(af, (af.value || '').trim().length > 3);
    });

    /* 4) Verwaiste Hinweise außerhalb von Stationen entfernen */
    document.querySelectorAll('.cd-required-hint').forEach(function (h) {
      if (!h.closest('.cd-station, [class*="cd-station"]')) h.remove();
    });

    /* 5) ERST JETZT Panel-Hintergründe neutralisieren — nach dem Taggen, sonst
       trifft es den noch unerkannten Adress-Trigger (V-Fix). */
    /* Mobile: keine Flächen-Neutralisierung (Overlay-Schutz) — NUR diesen Schritt
       überspringen, nicht die ganze Funktion. */
    if (!isMobile()) {
      widget.querySelectorAll('div, section, fieldset').forEach(function (el) {
        if (el.matches('.cd-station, .cd-station *, .tee-radio, .tee-radio *, .cd-address-trigger, .cd-address-trigger *, .cd-addr-field, .cd-pin')) return;
        if (isOverlay(el)) return; // Drawer/Modal/Dropdown behalten ihre Fläche
        var bg = getComputedStyle(el).backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
          el.style.setProperty('background', 'transparent', 'important');
          el.style.setProperty('border', '0', 'important');
          el.style.setProperty('box-shadow', 'none', 'important');
        }
      });
    }

    /* 6) Leerflächen einklappen (zuletzt, wenn alles final ist) */
    collapseEmpties(widget);
    collapseEmpties(document.querySelector('.product__info-container') || widget);
  }

  /* (entfernt) Diagnose OHNE Konsole — frueher: Seite mit ?cdxdiag=1 aufrufen —
     blendet unten eine Box mit den wichtigsten Messwerten ein (screenshotbar). */
  /* Das Diagnose-Overlay (?cdxdiag=1) samt CSS-Bisektion ist vor dem Relaunch
     entfernt. Es hat seinen Zweck erfuellt — die Galerie- und Einblende-Fehler
     sind darueber gefunden worden — war aber selbst eine Fehlerquelle: Es rechnete
     bei jeder DOM-Aenderung neu und bremste Teeinblues Aufbau aus. Was bleibt, ist
     der passive Fehler-Rekorder im Seitenkopf (window.__cdxErrs). */

  var raf = null;
  new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; upgrade(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value', 'class'] });
  document.addEventListener('input', upgrade, true);
  document.addEventListener('change', upgrade, true);

  if (document.readyState !== 'loading') upgrade();
  else document.addEventListener('DOMContentLoaded', upgrade);
})();
